import { GroupModel } from "../organisation/GroupModel"
import { Position } from "../organisation/OrganisationModelV2"
import { BidModel, buildBidModel } from "./BidModel"

export class OrgBidModel {
    organisationId?: number
    organisationName?: string
    organisationPosition?: Position
    bids: BidModel[]
    groups: GroupModel[]

    constructor(b: any) {
        this.organisationId = b.organisation_id
        this.organisationName = b.organisation_name
        this.organisationPosition = Position.build(b.organisation_position)
        this.bids = b.bids?.map(b => buildBidModel(b))
        this.groups = GroupModel.buildGroups(b.groups)
    }

    getTodayPrice(marketDay: string): BidModel | undefined {
        return this.bids.find(b => b.market_day === marketDay)
    }

    hasPosition() {
        return this.organisationPosition !== null && this.organisationPosition !== undefined
    }

    static buildOrgBid(p: any): OrgBidModel {
        return new OrgBidModel(p)
    }
}